import { render, staticRenderFns } from "./is_verified.vue?vue&type=template&id=4c01aa80&scoped=true"
import script from "./is_verified.vue?vue&type=script&lang=js"
export * from "./is_verified.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c01aa80",
  null
  
)

export default component.exports